module.exports = __webpack_public_path__ + "static/img/menu1.6a9e1318.png";